import { firstValueFrom, Observable } from 'rxjs';

export const sanitizeHtml = (rawHtml: string | undefined) => {
	if (!rawHtml) {
		return undefined;
	}
	const html = rawHtml.replace(/\\"/g, `"`);
	return html;
};

export const sanitizeFileName = (name: string): string => {
	return name.replace(/[/:*?"<>|#%!]/g, '').trim();
};

/**
 * supports Canadian and US postal code
 */
export const postalCodePatternRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

/**
 * supports the following
 * 123-456-7890
 * (123) 456-7890
 *  123 456 7890
 *  123.456.7890
 *  +91 (123) 456-7890
 */
export const phoneNumberPatternRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

export const isValidHttpUrl = (string: string) => {
	let url;

	try {
		url = new URL(string);
	} catch (_) {
		return false;
	}

	return url.protocol === 'http:' || url.protocol === 'https:';
};

export const formatTime = (time: number) => {
	const minutes = Math.floor(time / 60);
	const seconds = Math.floor(time % 60);
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const toMySQLDate = (date?: Date, options: object[] = [], separator?: string) => {
	if (separator === undefined) separator = '-';
	if (!options.length) options = [{ year: 'numeric' }, { month: '2-digit' }, { day: '2-digit' }];

	return options
		.map((option) => {
			const formatter = new Intl.DateTimeFormat('en', option);
			return formatter.format(date);
		})
		.join(separator);
};

export const langTag = (lang: Record<string, string>, key: string) => {
	return lang?.[key] || key;
};

export async function getKeyValueLangTag$(lang$: Observable<Record<string, string>>, key: string): Promise<string> {
	const tags = await firstValueFrom(lang$);
	return tags?.[key] || key;
}

export const MAX_INT = 2147483647;

export const pad = (n: number): string => (n < 10 ? '0' + n : n.toString());
